<template>
  <div
    class="details-container"
    @click.stop=""
  >
    <div
      style="width: 90%; height: 90%; margin: auto;"
      class="mt-3 mb-2 text-center"
    >
      <img
        id="imageCont"
        :src="base64String"
        class="img-fluid d-block mx-auto large-image"
        style="object-fit: contain"
      />
      <rotate-image-buttons
        v-if="controls"
        image-container-id="imageCont"
        style="z-index: 10;"
        :save-disabled="true"
        :show-download-button="true"
        :photo-url="base64String"
        :photo-id="photoId"
        @save-clicked="saveRotation"
        @download-image="handleDownload"
      />
    </div>
    <font-awesome-icon
      icon="times-circle"
      class="close-dialog-icon colored-border"
      @click.stop="$emit('close')"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import RotateImageButtons from '@/components/view/RotateImageButtons'
import { downloadHelper } from '../mixins/DownloadMixin'

export default {
    name: 'FullscreenBase64Image',
    components: {RotateImageButtons},
    mixins: [restApi, downloadHelper],
    props: {
        base64String: null,
        photoId: {
            type: [String, Number],
            default: 'photo'
        },
        controls: {
            type: Boolean,
            default() {
                return true
            }
        }
    },
    methods: {
        saveRotation(rotation) {
            this.$emit('rotationChanged', rotation)
        },
        handleDownload() {
            this.downloadBase64Image(this.base64String, `photo_${this.photoId}.jpg`)
        }
    }
}
</script>

<style>

.large-image {
    overflow: hidden;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    Transition: transform 0.3s ease;
}

.colored-border {
    border: 0.07em solid black;
    background-color: black;
    border-radius: 50%;
}

</style>
